import mixpanel from 'mixpanel-browser';

// Initialisiere Mixpanel mit deinem Token

mixpanel.init('2e8ab5a38d8a9ea2f1eb817d564de570', {
    autocapture: true,
    debug: true,
    track_pageview: true,
    record_sessions_percent: 100,
    api_host: 'https://api-eu.mixpanel.com',
  })
;

export default mixpanel;